module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAArklEQVRYR2M8k2b8n2EAAeOoA0ZDYDQEhlQI6PftZWDm5MVbavz/84vhfK4N0SULSeWAfv9+BhYuXoav968w/P35Hasl///+ZrgzKY+2DrjaGM7w49ldoi3Bp5CsEBh1wGgIfH96h+Hfrx8Yaev3p3cMd6cVkZQ4yUqEf398Zfj/7x+mA96/ZLjWFEF7B4ymgdEQGA2BAQsBkjI4kYpJKoiINJMkZaMOGA2B0RAAAFUKvqHDPy5LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicons/favicon-32x32.png
// module id = sCl4
// module chunks = 1